export default "__VITE_ASSET__BOI7ESnx__"